namespace TabAurous.ECommerce {
    export namespace ECommRepairItemsBOMService {
        export const baseUrl = 'ECommRepair/ECommRepairItemsBOM';

        export declare function Create(request: Serenity.SaveRequest<ECommRepairItemsBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommRepairItemsBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommRepairItemsBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ECommRepairItemsBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommRepair/ECommRepairItemsBOM/Create",
            Update = "ECommRepair/ECommRepairItemsBOM/Update",
            Delete = "ECommRepair/ECommRepairItemsBOM/Delete",
            Retrieve = "ECommRepair/ECommRepairItemsBOM/Retrieve",
            List = "ECommRepair/ECommRepairItemsBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ECommRepairItemsBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
